<template>
  <div v-if="professores" :class="['col-xs-12', `col-md-${size}`]">
    <form-group-select
      ref="input"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :options="professores"
      :data-vv-as="label"
      placeholder="Selecione"
      @input="atualizarProfessor($event)"
      @change="atualizarProfessor($event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
import ProfessorService from "../../../../domain/corpore/ProfessorService";
import CampoEnum from "../../../../domain/protocolo/CampoEnum";
import SwalMessage from "../../../../domain/message/SwalMessage";

export default {
  name: "c-protocolo-professor",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator", "formValues"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    size: {
      type: String,
      default: "6"
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  data() {
    return {
      campoEnum: CampoEnum
    };
  },
  mounted() {
    this.$el.value = this.value;
  },
  asyncComputed: {
    professores() {
      let curso = this.formValues.cursoId;
      if (curso) {
        const professorService = new ProfessorService(this.$http);
        return professorService
          .getProfessoresByCurso(curso)
          .then(result => {
            return result.map(periodo => ({
              value: periodo.codprof,
              text: periodo.nome
            }));
          })
          .catch(err => {
            SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
          });
      }
    }
  },
  methods: {
    atualizarProfessor(value) {
      this.formValues.professorId = value;
      this.$emit("input", value);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/Professor.vue